import ApiService from "@/core/services/api.service";

const LEGACY_KEY = "medhop_quick_access";

const parseStorageObject = key => {
  try {
    return JSON.parse(window.localStorage.getItem(key) || "null");
  } catch (error) {
    return null;
  }
};

const cacheKey = () => {
  const user = parseStorageObject("user") || {};
  const tenant = parseStorageObject("tenantconfig") || {};
  const tenantId = tenant.database_name || tenant.id || "tenant";
  const userId = user.id || user.user_id || user.email || "user";
  return `medhop_quick_access:${tenantId}:${userId}`;
};

const readCache = () => {
  const saved = parseStorageObject(cacheKey());
  return Array.isArray(saved) ? saved.slice(0, 7) : null;
};

const writeCache = selection => {
  window.localStorage.setItem(cacheKey(), JSON.stringify(selection.slice(0, 7)));
};

const migrateLegacyCache = () => {
  const legacy = parseStorageObject(LEGACY_KEY);
  if (!Array.isArray(legacy)) return null;

  const selection = legacy.slice(0, 7);
  writeCache(selection);
  window.localStorage.removeItem(LEGACY_KEY);
  return selection;
};

export const loadQuickAccess = async () => {
  try {
    const response = await ApiService.get("user-preferences/quick-access");
    const selection = response && response.data && response.data.data
      ? response.data.data.quick_access
      : null;
    if (Array.isArray(selection)) {
      writeCache(selection);
      return selection.slice(0, 7);
    }
  } catch (error) {
    // Cache menjaga tray tetap tersedia ketika layanan preferensi tidak terjangkau.
  }

  return readCache() || migrateLegacyCache();
};

export const saveQuickAccess = async selection => {
  const normalized = selection.slice(0, 7);
  await ApiService.update("user-preferences", "quick-access", {
    quick_access: normalized,
  });
  writeCache(normalized);
  return normalized;
};

export default { loadQuickAccess, saveQuickAccess };
